import {
  INCIDENT_LIFECYCLE_LABELS,
  INCIDENT_LIFECYCLE_PHASES,
  lifecyclePhaseIndex,
  type IncidentLifecyclePhase,
} from "@/lib/incidentLifecycle";

interface IncidentLifecycleBarProps {
  phase: IncidentLifecyclePhase;
}

export function IncidentLifecycleBar({ phase }: IncidentLifecycleBarProps) {
  const currentIndex = lifecyclePhaseIndex(phase);

  return (
    <nav className="incident-lifecycle" aria-label="Incident lifecycle">
      <ol className="incident-lifecycle__track">
        {INCIDENT_LIFECYCLE_PHASES.map((step, index) => {
          const state =
            index < currentIndex ? "complete" : index === currentIndex ? "current" : "upcoming";
          return (
            <li
              key={step}
              className={`incident-lifecycle__step incident-lifecycle__step--${state}`}
              aria-current={state === "current" ? "step" : undefined}
            >
              <span className="incident-lifecycle__marker" aria-hidden="true">
                {index + 1}
              </span>
              <span className="incident-lifecycle__label">{INCIDENT_LIFECYCLE_LABELS[step]}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
